/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { FaLocationDot } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import { LuPhoneCall } from "react-icons/lu";
import "./../Pages/contact-us.css";
import ContactForm from "../components/ContactForm";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import SeoHelmet from "../Seo/SeoHelmet";
const ContactUs = () => {
  return (
    <div>
      <SeoHelmet page="contact" />
      <BreadcrumbBanner
        title="Contact Us"
        backgroundImage="/Images/banner-about.jpg"
      />

      <section className="contact-info-wrapper">
      <div className="contact-info-card">
        {/* Contact Block 1: Phone */}
        <div className="info-block">
          <div className="icon-circle">
            <LuPhoneCall className="icon-size" />
          </div>
          <div className="info-text">
            <a href="tel:+61452246919">+61 452 246 919</a>
            <br />
            <a href="tel:+61482603476">+61 482 603 476</a>
          </div>
        </div>

        {/* Contact Block 2: Email */}
        <div className="info-block">
          <div className="icon-circle">
            <IoIosMail className="icon-size" />
          </div>
          <div className="info-text">
            <a href="mailto:mandurahcafe01@gmail.com">
              mandurahcafe01@gmail.com
            </a>
          </div>
        </div>

        {/* Contact Block 3: Location */}
        <div className="info-block">
          <div className="icon-circle">
            <FaLocationDot className="icon-size" />
          </div>
          <div className="info-text">
            <a
              href="https://maps.app.goo.gl/nzfWjHE1NPPe8KtE9"
              target="_blank"
              rel="noopener noreferrer"
            >
              31 Sholl St, Mandurah WA 6210
              <br />
              Australia
            </a>
          </div>
        </div>
      </div>
    </section>
      <ContactForm />
      <section className="map-wrapper">
        <h2 className="map-heading">Mandurah Cafe | Cafe in Mandurah | Coffee Shop Mandurah</h2>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3363.8201532258026!2d115.72191999999998!3d-32.53095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a327fd227c873c7%3A0xa028bed502d57d2c!2sMandurah%20Cafe!5e0!3m2!1sen!2sin!4v1750164331834!5m2!1sen!2sin"
            // width="600"
            // height="450"
            // style="border:0;"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
